import axios from '@plugins/axios'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

let serverUrl = appConfig.server_url

export const state = {
  assessments: { results: [] },
  assessmentTypes: { results: [] },
  submittingAssessment: false,
  deletingAssessment: false,
}

export const getters = {
  submittingAssessment: (state) => state.submittingAssessment,
  assessmentTypes: (state) => state.assessmentTypes,
  deletingAssessment: (state) => state.deletingAssessment,
}

export const mutations = {
  CACHE_ASSESSMENT(state, data) {
    state.assessments = data
  },
  CACHE_ASSESSMENT_TYPES(state, data) {
    state.assessmentTypes = data
  },
  SUBMITTING(state, value) {
    state.submittingAssessment = value
  },
  DELETING(state, deleting) {
    state.deletingAssessment = deleting
  },
}

export const actions = {
  async fetchAssesments({ commit }, query = '') {
    try {
      const res = await axios.get(`${serverUrl}/assessment/assessment/${query}`)
      commit('CACHE_ASSESSMENT', res.data)
      return { success: true, error: null, data: res.data }
    } catch (error) {
      return { success: false, error, data: null }
    }
  },

  async fetchAssesmentTypes({ commit }, query = '') {
    try {
      const res = await axios.get(
        `${serverUrl}/assessment/assessmenttype/${query}`
      )
      commit('CACHE_ASSESSMENT_TYPES', res.data)
      return { response: res }
    } catch (err) {
      return err
    }
  },

  async createUpdateAssesment({ commit }, { method, payload }) {
    const url = method === 'put'
      ? payload.url
      : `${serverUrl}/assessment/assessment/`

    commit('SUBMITTING', true)
    try {
      const res = await axios[method](url, payload)
      commit('SUBMITTING', false)
      return { error: null, data: res.data }
    } catch (error) {
      commit('SUBMITTING', false)
      return { error, data: null }
    }
  },

  async deleteAssessment({ commit }, url) {
    commit('DELETING', true)
    try {
      const res = await axios.delete(url)
      commit('DELETING', false)
      return { success: true, status: res.status }
    } catch (error) {
      commit('DELETING', false)
      return { success: false, error }
    }
  },

  async checkPasswordAssessment(_, { payload }) {
    const url = `${payload.url}check_password/`
    try {
      const res = await axios.post(url, payload)
      return { error: null, status: res.status }
    } catch (error) {
      return { error }
    }
  },

  getDepartments(_, assessmentId) {
    return axios.get(`${serverUrl}/assessment/assessment/${assessmentId}/departments/`)
  },
  
  getPassword(_, assessmentUrl) {
    return axios.get(`${assessmentUrl}get_password/`)
  }
}


